import React from 'react';
import styled from 'styled-components';

import { HeaderMenu } from '#/components/layout/header/HeaderMenu';
import '#/reduxState/exchange/userGuideReducer';

import HeaderChainLogo from './HeaderChainLogo';
import { HeaderMenuWallet } from './HeaderMenuWallet';

const Wrapper = styled.div`
  grid-area: header;
  height: var(--header-height);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const MenuWrap = styled.div`
  display: flex;
  align-items: center;
`;

function Header() {
  return (
    <Wrapper>
      <MenuWrap>
        <HeaderChainLogo />
        <HeaderMenu />
      </MenuWrap>
      <HeaderMenuWallet />
    </Wrapper>
  );
}

export default Header;
